var HOSTNAME = {
  dev: 'https://dpp-provider-gateway-test.mlp-ext-test.aws.cloud.lfg.com',
  nonProd: 'https://provider.np-mylincolnportal.com',
  prod: 'https://provider.mylincolnportal.com'
};
var ADMIN_HOSTNAME = {
  dev: 'https://mlp-admin-gateway-dev.mlp-ext-dev.aws.cloud.lfg.com',
  nonProd: 'https://admin.np-mylincolnportal.com/',
  prod: 'https://admin.mylincolnportal.com/'
};
var ENVIRONMENT_VARIABLES = {
  auth0Audience: {
    dev: 'com.lfg.digital.portal.dpp.api.external',
    nonProd: 'com.lfg.digital.portal.dpp.api.external',
    prod: 'com.lfg.digital.portal.dpp.api.external'
  },
  auth0Domain: {
    dev: 'provider-auth.np-mylincolnportal.com',
    nonProd: 'provider-auth.np-mylincolnportal.com',
    prod: 'provider-auth.mylincolnportal.com'
  },
  auth0ClientId: {
    dev: 'x3uqX5II5QXRBbSqr3UfdpnOZ0J1rA3s',
    nonProd: 'x3uqX5II5QXRBbSqr3UfdpnOZ0J1rA3s',
    prod: '7Hg2Vq3ywjUNQtnVpzziBO5KWbU7okpk'
  },
  auth0RedirectUri: {
    dev: "http://".concat(window.location.host, "/dental/authn-callback"),
    nonProd: HOSTNAME.nonProd + '/dental/authn-callback',
    prod: HOSTNAME.prod + '/dental/authn-callback'
  },
  threatMetrixOrgId: {
    dev: '38u7vvif',
    nonProd: '38u7vvif',
    prod: '4y498eek'
  },
  captchaSiteKey: {
    dev: '6Lc7wfYUAAAAAMDLPWWlYk8RauIV0kMbPoA1fc0q',
    nonProd: '6Lc7wfYUAAAAAMDLPWWlYk8RauIV0kMbPoA1fc0q',
    prod: '6LdQwfYUAAAAAJiJF2kNQ0ibOO_kp8Ndo2RWrLUA'
  },
  recaptchaEnterpriseSiteKey: {
    dev: '6LfrNfsrAAAAAIH4xd123cJPB6PuY4cLs98evVRE',
    nonProd: '6LfrNfsrAAAAAIH4xd123cJPB6PuY4cLs98evVRE',
    prod: '6LfCOfsrAAAAAMm0FkWvI-4EVejWIP59iorSxabV'
  },
  providerVanityURL: {
    dev: HOSTNAME.dev + '/',
    nonProd: HOSTNAME.nonProd + '/',
    prod: HOSTNAME.prod + '/'
  },
  adminApp: {
    dev: 'http://localhost:8090',
    nonProd: ADMIN_HOSTNAME.nonProd,
    prod: ADMIN_HOSTNAME.prod
  },
  LOGROCKET_APP_ID: {
    dev: 'o1n3rt/dental-provider-portal',
    nonProd: 'o1n3rt/dental-provider-portal',
    prod: 'o1n3rt/dental-provider-portal-production'
  },
  LOGROCKET_APP_SLUG: {
    dev: 'dental-provider-portal',
    nonProd: 'dental-provider-portal',
    prod: 'dental-provider-portal-production'
  },
  LOGROCKET_API_KEY: {
    dev: 'o1n3rt:dental-provider-portal:lWIe4iYe7rCmFebUktel',
    nonProd: 'o1n3rt:dental-provider-portal:lWIe4iYe7rCmFebUktel',
    prod: 'o1n3rt:dental-provider-portal-production:wPW5GgJRe0ufWqM8HiMe'
  },
  googleRecaptchaEnterprise: {
    dev: false,
    nonProd: true,
    prod: true
  }
};
export default ENVIRONMENT_VARIABLES;